import {
  Component,
  Input,
  OnInit,
  ViewChild,ElementRef
} from '@angular/core';

import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-cus-wallet',
  templateUrl: './cus-wallet.component.html',
  styleUrls: ['./cus-wallet.component.scss'],
})
export class CusWalletComponent implements OnInit {
  @Input() customer_id: any;
  wallet_detail: any = [];
  page_no = 1;
  scroll_evt = true;
  @ViewChild('scrollMe') private myScrollContainer:any = ElementRef;

  constructor(public db:DataService) { }

  ngOnInit() {
    this.get_wallet_details();
    this.db.Wallet_points = false;
  }

  get_wallet_details(){
    let data = {
      list_type: 'app_pay',
      vendor: this.customer_id.name,
      page_no: this.page_no,
      page_len: 10
    }
    // this.db.get_wallet_details(data).subscribe(res => {
      
    //   if(res.message.length != 0){
    //     this.wallet_detail = res.message[0];
    //     this.db.Wallet_points = false; 
    //   }
    //   else {
    //     this.db.Wallet_points = true; 
    //   }   
    // })

    this.db.get_wallet_details(data).subscribe(res=>{ 
      if(this.page_no == 1){
    
        if(res.message && res.message[0] && res.message[0].transactions && res.message[0].transactions.length != 0){
          this.wallet_detail = res.message[0]
          this.scroll_evt = true;
          this.db.Wallet_points = true; 
        }else{
          this.scroll_evt = false;
          this.db.Wallet_points = true; 
        }
        
      } else{

        if(res.message && res.message[0] && res.message[0].transactions && res.message[0].transactions.length != 0){
          res.message[0].transactions.map(r=>{
            this.wallet_detail.transactions.push(r);
          })
          this.scroll_evt = true;
          this.db.Wallet_points = true; 
        }else{
          this.scroll_evt = false;
          this.db.Wallet_points = true; 
        }
        
      }   
    })

  }
  
  doRefresh(event) {
    // console.log('Begin async operation');
    this.get_wallet_details();
    // this.db.get_razorpay_settings();
    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 700);
  }

  onScroll(event: any) {
    // console.log(this.scroll_evt)
    // console.log(this.db.inventory_page_no)
     if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight && this.scroll_evt) {
      this.page_no = this.page_no + 1;
       this.get_wallet_details();
     }
   }

}
